<template>
  <div class="animated fadeIn pb-8 admin-comments">
    <div v-if="!loaded" class="d-flex flex-column align-items-center mt-8 py-6">
      <atom-spinner :animation-duration="1000" :size="80" :color="'#7c4dff'" />
      <p class="primary--text font-weight-bold mt-4">
        در حال بارگذاری اطلاعات...
      </p>
    </div>
    <div v-else>
      <v-card class="common-card">
        <div>
          <h4 class="c-grey">نظرات</h4>
        </div>
        <hr class="mt-5" />

        <v-row>
          <v-col cols="12" sm="6">
            <div class="custom-input mt-5">
              <v-text-field
                outlined
                dense
                label="جستجو در نام کتاب..."
                v-model="filterComment"
                color="#7c4dff"
                prepend-inner-icon="$Search"
              >
                <template v-slot:append>
                  <v-icon
                    v-if="filterComment.length"
                    class="red--text"
                    @click="filterComment = ''"
                    >mdi-close-circle-outline
                  </v-icon>
                </template>
              </v-text-field>
            </div>
          </v-col>
        </v-row>
        <div class="custom-table">
          <div class="custom-table-vue mt-3">
            <v-data-table
              responsive
              show-empty
              :current-page="currentPage"
              :items-per-page="perPage"
              :page.sync="currentPage"
              :items="computedComments"
              :headers="headers"
              @click:row="openExpandByClickingOnRow"
              hide-default-footer
              :single-expand="singleExpand"
              :expanded.sync="expanded"
              show-expand
              item-key="id"
            >
              <template v-slot:no-data>
                <p class="mt-3">موردی جهت نمایش وجود ندارد.</p>
              </template>
              <template v-slot:[`item.index`]="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 + perPage * (currentPage - 1) }}
                </div>
              </template>
              <template v-slot:[`item.warehouseItemName`]="{ item }">
                <div style="text-align: center; vertical-align: middle">
                  <a
                    :href="'/productDetails/' + item.warehouseItemId"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {{ item.warehouseItemName }}
                  </a>
                </div>
              </template>
              <template v-slot:[`item.shopCustomerName`]="{ item }">
                <div
                  v-if="item.shopCustomerId"
                  style="text-align: center; vertical-align: middle"
                >
                  <a
                    :href="'/shop/customer/' + item.shopCustomerId"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {{ item.shopCustomerName }}
                  </a>
                </div>
                <div v-else style="text-align: center; vertical-align: middle">
                  {{ item.shopCustomerName }}
                </div>
              </template>
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length" class="py-4">
                  <v-btn
                    v-if="item.status == 'ثبت شده'"
                    width="155"
                    height="40"
                    class="green-mainBtn ms-4 me-4 white--text mb-sm-0 mb-3"
                    @click="approveDialog(item)"
                    ><v-icon class="me-1">mdi-check</v-icon>تایید نظر</v-btn
                  >
                  <v-btn
                    v-if="item.status == 'ثبت شده'"
                    width="155"
                    height="40"
                    class="red-mainBtn ms-4 me-4 white--text mb-sm-0 mb-3"
                    @click="rejectDialog(item)"
                    ><v-icon class="me-1">mdi-close</v-icon>رد نظر</v-btn
                  >
                  <v-btn
                    v-if="item.status == 'تایید شده'"
                    width="155"
                    height="40"
                    class="secondary white--text ms-4 me-4"
                    @click="replyDialog(item)"
                    ><v-icon class="me-1"> mdi-chat-outline </v-icon>
                    {{
                      item.isRepliedByAdmin == true ? "ویرایش پاسخ" : "پاسخ"
                    }}</v-btn
                  >
                  <p class="pt-3" v-if="item.status == 'رد شده'">
                    عملیاتی برای نظرات رد شده وجود ندارد.
                  </p>
                </td>
              </template>
              <template v-slot:[`item.status`]="{ item }">
                <v-chip
                  class="white--text"
                  :color="
                    item.status == 'تایید شده'
                      ? '#37a014'
                      : item.status == 'رد شده'
                      ? '#f3536e'
                      : item.status == 'ثبت شده'
                      ? 'warning'
                      : 'adminPrimary'
                  "
                >
                  {{ item.status }}
                </v-chip>
              </template>
              <template v-slot:[`item.text`]="{ item }">
                <div v-if="item.text.length > 15">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attr }">
                      <span v-on="on" v-bind="attr">
                        {{ item.text.slice(0, 15) }} </span
                      ><span>...</span>
                    </template>
                    <div>
                      <span>
                        {{ item.text }}
                      </span>
                    </div>
                  </v-tooltip>
                </div>
                <div v-else>{{ item.text }}</div>
              </template>
              <template v-slot:[`expanded-item`]="{ headers, item }">
                <td
                  :colspan="headers.length"
                  class="text-center d-none d-sm-table-cell"
                >
                  <div class="py-2">
                    <!--                    <v-btn-->
                    <!--                      color="blue"-->
                    <!--                      class="text-center text-white me-7"-->
                    <!--                      @click="openReplyDialog=true"-->
                    <!--                    >-->
                    <!--                      پاسخ دادن-->
                    <!--                    </v-btn>-->
                    <v-btn
                      color="blue"
                      class="text-center text-white me-7"
                      @click="
                        openCommentInfo = true;
                        selectedRow = item;
                      "
                    >
                      جزییات
                    </v-btn>
                    <!--                    <v-btn-->
                    <!--                      color="blue"-->
                    <!--                      class="text-center text-white me-7"-->
                    <!--                      @click="openCommentInfo=true"-->
                    <!--                    >-->
                    <!--                      پذیرفتن-->
                    <!--                    </v-btn>-->
                  </div>
                </td>
                <td
                  :colspan="headers.length"
                  class="text-center d-flex justify-center h-100 d-sm-none"
                >
                  <div class="py-2">
                    <v-btn
                      @click="openFormDetailes(item)"
                      class="my-2 me-1"
                      width="120"
                      height="42"
                      color="primary"
                      ><v-icon class="me-1">$Show</v-icon>جزئیات</v-btn
                    >
                    <v-btn
                      @click="openNoteDialog(item)"
                      class="my-2 white--text ms-3"
                      width="120"
                      height="42"
                      color="yellow darken-4"
                      ><v-icon class="me-1">$Text</v-icon>یادداشت</v-btn
                    >
                  </div>
                </td>
              </template>
            </v-data-table>

            <v-row class="mt-6">
              <v-col>
                <div class="d-flex flex-row">
                  <span class="c-grey pt-2">نمایش در هر صفحه</span>
                  <div class="ms-3 me-3 number-box">
                    <v-select
                      outlined
                      v-model="perPage"
                      :items="perPageItems"
                      @change="currentPage = 1"
                    >
                    </v-select>
                  </div>
                </div>
              </v-col>
              <v-col class="d-flex flex-row">
                <span class="c-grey pt-2"> برو به صفحه </span>
                <div class="ms-3 me-3 number-box">
                  <v-select
                    outlined
                    v-model="whichPage"
                    type="number"
                    @change="goToPage()"
                    @click="goToPage()"
                    :items="computedIndex"
                  ></v-select>
                </div>
              </v-col>
              <v-col class="text-sm-center">
                <div>
                  <v-pagination
                    v-model="currentPage"
                    prev-icon="$ArrowLeft"
                    next-icon="$ArrowRight"
                    :length="Math.ceil(computedComments.length / perPage)"
                    :total-visible="5"
                    class="float-sm-end"
                    @change="goToPage()"
                  >
                  </v-pagination>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-card>
      <v-dialog v-model="openCommentInfo" width="400">
        <v-card>
          <v-card-title class="white"
            ><v-row>
              <v-col>
                <h4
                  class="c-grey mb-0 pb-0 fs-medium font-weight-bold"
                  style="vertical-align: middle"
                >
                  {{ selectedRow.warehouseItemName }}
                </h4>
                <h6 class="c-grey">
                  (وضعیت: {{ selectedRow.status }})
                </h6>
              </v-col>
              <v-col cols="2" class="text-left pt-2">
                <span class="pointer" @click="openCommentInfo = false"
                  ><v-icon>$Close</v-icon></span
                >
              </v-col>
            </v-row></v-card-title
          >
          <hr class="mb-3 mt-0 pt-0" />
          <v-card-text class="pa-3 pt-0 pb-5 black--text">
            {{ selectedRow.text }}
            <div class="text-left pe-3 pb-1 pt-2 mt-2">
              <v-btn
                class="purple-mainBtn white--text me-3"
                @click="openReplyDialog = true"
              >
                پاسخ دادن
              </v-btn>
              <v-btn
                class="green-mainBtn white--text me-3"
                @click="confirmComment(selectedRow)"
                v-if="selectedRow.status != 'تایید شده'"
              >
                تایید کردن
              </v-btn>
              <v-btn
                class="red-mainBtn white--text me-3"
                @click="rejectComment(selectedRow)"
                v-if="selectedRow.status != 'رد شده'"
              >
                رد کردن
              </v-btn>
              <!--              <v-btn class="yellow-mainBtn" @click="openCommentInfo = false">-->
              <!--                بستن-->
              <!--              </v-btn>-->
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="openRejectDialog" width="400">
        <v-card>
          <v-card-title class="white"
            ><v-row>
              <v-col>
                <h4 class="c-grey mb-0">رد نظر</h4>
              </v-col>
              <v-col cols="2" class="text-left pt-2">
                <span class="pointer" @click="openRejectDialog = false"
                  ><v-icon>$Close</v-icon></span
                >
              </v-col>
            </v-row></v-card-title
          >
          <hr class="mb-3 mt-0 pt-0" />
          <v-card-text class="pa-3 pt-0 pb-5 black--text">
            شما در حال رد این نظر هستید. آیا اطمینان دارید؟
            <div class="text-left pe-3 pb-1 pt-2 mt-2">
              <v-btn
                class="green-mainBtn white--text me-3"
                @click="rejectComment(selectedRow)"
              >
                رد کردن
              </v-btn>
              <v-btn class="red-mainBtn" @click="openRejectDialog = false">
                بستن
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="openReplyDialog" width="400">
        <v-card>
          <v-card-title class="white">
            <v-row>
              <v-col>
                <h4 class="c-grey mb-0">پاسخ‌دهی</h4>
              </v-col>
              <v-col cols="2" class="text-left pt-2">
                <span class="pointer" @click="openReplyDialog = false"
                  ><v-icon>$Close</v-icon></span
                >
              </v-col>
            </v-row></v-card-title
          >
          <div class="pa-3 black--text">
            لطفا توجه کنید پاسخ تنها در صورتی منتشر میشود که نظر اولیه تایید شده
            باشد. وضعیت فعلی نظر: {{ selectedRow.status }}
          </div>
          <hr class="mb-3 mt-0 pt-0" />
          <v-card-text class="pa-3 black--text">
            <v-textarea
              class="px-2"
              outlined
              dense
              v-model="selectedRow.text"
              disabled
              label="نظر کاربر"
            >
            </v-textarea>
            <v-textarea
              class="px-2"
              v-model="selectedRow.adminReply"
              outlined
              dense
              label="پاسخ شما"
            >
            </v-textarea>
            <div class="text-left pe-3 pb-4 pt-2">
              <v-btn
                class="green-mainBtn white--text me-3"
                @click="replyComment(selectedRow)"
                width="100"
              >
                ارسال پاسخ
              </v-btn>
              <v-btn
                class="red-mainBtn"
                @click="openReplyDialog = false"
                width="100"
              >
                بستن
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import Axios from "axios";
import { AtomSpinner } from "epic-spinners";
export default {
  components: {
    AtomSpinner,
  },
  data() {
    return {
      loaded: false,
      currentPage: 1,
      perPage: 5,
      openCommentInfo: false,
      openRejectDialog: false,
      openReplyDialog: false,
      filterComment: "",

      expanded: [],
      selectedRow: [],
      singleExpand: false,
      headers: [
        { value: "index", text: "ردیف", sortable: false },
        { value: "date", text: "تاریخ", sortable: false },
        { value: "time", text: "ساعت", sortable: false },
        { value: "warehouseItemName", text: "نام کتاب", sortable: false },
        { value: "shopCustomerName", text: "نام مشتری", sortable: false },
        { value: "title", text: "عنوان", sortable: false },
        { value: "text", text: "متن نظر", sortable: false },
        { value: "status", text: "وضعیت", sortable: false },
        { value: "data-table-expand", text: "عملیات", sortable: false },
      ],
      perPageItems: [5, 10, 20],
      comments: [],
      allComments: [],
      whichPage: 1,
    };
  },
  methods: {
    goToPage() {
      this.currentPage = Number(this.whichPage);
    },
    openExpandByClickingOnRow(item, event) {
      if (event.isExpanded) {
        const indexExpanded = this.expanded.findIndex((i) => i === item);
        this.expanded.splice(indexExpanded, 1);
      } else {
        this.expanded.push(item);
      }
    },
    approveDialog(item) {
      this.openCommentInfo = true;
      this.selectedRow = item;
    },
    rejectDialog(item) {
      this.openRejectDialog = true;
      this.selectedRow = item;
    },
    replyDialog(item) {
      this.openReplyDialog = true;
      this.selectedRow = item;
    },
    getComments() {
      Axios.get(this.baseUrl + "/satrapp/shop/comments/list", {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("token"),
        },
      })
        .then((res) => {
          if (res.status == 200) {
            this.loaded = true;
            this.comments = res.data;
            this.allComments = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.loaded = true;
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.loaded = true;
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    confirmComment() {
      this.loaded = false;
      Axios.patch(
        this.baseUrl + "/satrapp/shop/comment/approve/" + this.selectedRow.id,
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.getComments();
            this.openCommentInfo = false;
            this.loaded = true;

            this.toast(res.data.message, "success");
          } else {
            this.loaded = true;

            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");

            this.openCommentInfo = false;
          }
        })
        .catch((err) => {
          this.loaded = true;
          this.toast("خطا: " + err.response.data, "error");
          this.openCommentInfo = false;
        });
    },
    rejectComment() {
      this.loaded = false;
      Axios.patch(
        this.baseUrl + "/satrapp/shop/comment/reject/" + this.selectedRow.id,
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.getComments();
            this.openRejectDialog = false;
            this.openCommentInfo = false;
            this.loaded = true;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.loaded = true;
            this.openRejectDialog = false;
            this.openCommentInfo = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.openRejectDialog = false;
        });
    },
    replyComment() {
      this.loaded = false;
      Axios.post(
        this.baseUrl + "/satrapp/shop/comment/reply/" + this.selectedRow.id,
        {
          text: this.selectedRow.adminReply,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.loaded = true;

            this.toast(res.data.message, "success");
            this.selectedRow.adminReply = "";
            this.openReplyDialog = false;
            this.openCommentInfo = false;
            this.getComments();
          } else {
            this.loaded = true;

            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.openReplyDialog = false;
          }
        })
        .catch((err) => {
          this.loaded = true;

          this.toast(err.response.data, "error");
          this.openReplyDialog = false;
          this.openCommentInfo = false;
        });
    },
  },
  mounted() {
    this.getComments();
  },
  computed: {
    computedComments() {
      let filtered;
      if (this.filterComment.length) {
        filtered = this.comments.filter((x) =>
          x.warehouseItemName
            .toLowerCase()
            .includes(this.filterComment.toLowerCase())
        )
          ? this.comments.filter((x) =>
              x.warehouseItemName
                .toLowerCase()
                .includes(this.filterComment.toLowerCase())
            )
          : "";
      } else {
        filtered = this.comments;
      }
      return filtered;
    },
    computedIndex() {
      let arr = [];
      let computedLength = this.computedComments.length;
      let arrLength = Math.ceil(computedLength / this.perPage);
      for (let i = 1; i <= arrLength; i++) {
        arr.push(i);
      }
      return arr;
    },
  },
};
</script>
<style lang="scss">
.v-data-table
  > .v-data-table__wrapper
  tbody
  tr.v-data-table__expanded__content {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.admin-comments {
  .custom-input {
    .v-input__slot {
      width: 100% !important;
    }
    .v-input__control {
      flex-direction: row !important;
    }
    .v-text-field .v-input__control,
    .v-text-field fieldset {
      min-height: 45px !important;
      border-color: #7c4dff !important;
    }
    .v-label:not(.v-label--active) {
      transform: translateY(2px);
    }
    .theme--light.v-data-table .v-data-table-header th.sortable:hover {
      color: white !important;
    }
    .theme--light.v-data-table
      > .v-data-table__wrapper
      > table
      > thead
      > tr
      > th {
      color: white !important;
    }
    .v-data-table
      > .v-data-table__wrapper
      tbody
      tr.v-data-table__expanded__content {
      -webkit-box-shadow: none !important;
      box-shadow: none !important;
    }
    .theme--light.v-card > .v-card__subtitle,
    .theme--light.v-card > .v-card__text {
      color: black !important;
    }
    .theme--light.v-data-table {
      background-color: #fff;
      color: black !important;
    }
    table thead {
      color: black !important;
    }
    .custom-table-vue .v-data-table-header tr th {
      text-align: center !important;
      font-size: 15px !important;
      color: black !important;
      height: 50px !important;
    }
  }
}
</style>
